<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>
    <div class="toolbar">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openAdd">新增官方帐号</el-button>
    </div>
    <el-table
      class="official-account-table"
      :data="tableData"
      border
      stripe
      size="small"
      style="width: 100%; margin-top: 12px"
      v-loading="loading"
      empty-text="暂无数据，请点击左上方新增"
    >
      <el-table-column prop="id" label="#" width="64" align="center" />
      <el-table-column label="关联用户" min-width="260">
        <template slot-scope="scope">
          <div class="user-cell">
            <div class="user-cell__avatar">
              <img v-if="scope.row.photo" :src="scope.row.photo" alt="" />
              <span v-else class="user-cell__avatar-placeholder">
                <i class="el-icon-user-solid"></i>
              </span>
            </div>
            <div class="user-cell__meta">
              <div class="user-cell__nick" :title="displayNick(scope.row)">
                {{ displayNick(scope.row) }}
              </div>
              <div class="user-cell__sub">用户 ID {{ scope.row.officialUserId != null ? scope.row.officialUserId : "—" }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
      <el-table-column label="创建时间" width="158" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column label="更新时间" width="158" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.updateTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="148" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" class="btn-del" @click="delRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="520px"
      :close-on-click-modal="false"
      @closed="onDialogClosed"
    >
      <el-form v-if="form" ref="formRef" :model="form" :rules="rules" label-width="108px" size="small">
        <el-form-item label="官方帐号" prop="officialUserId" class="official-user-select-item">
          <el-select
            v-model="form.officialUserId"
            filterable
            remote
            reserve-keyword
            clearable
            placeholder="输入昵称关键字搜索，并选择用户"
            :remote-method="remoteSearchUser"
            :loading="userSearchLoading"
            style="width: 100%"
            popper-class="official-user-select-dropdown"
          >
            <el-option
              v-for="u in userSearchOptions"
              :key="'u-' + u.id"
              :label="userOptionLabel(u)"
              :value="u.id"
            />
          </el-select>
          <div class="field-hint">搜索小程序用户，选中后保存其用户 ID 为官方帐号</div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="可选" maxlength="200" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitFn">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  data() {
    return {
      historyArr: ["用户管理", "官方帐号列表"],
      loading: false,
      tableData: [],
      dialogVisible: false,
      dialogTitle: "新增官方帐号",
      form: null,
      submitLoading: false,
      rules: {
        officialUserId: [{ required: true, message: "请搜索并选择用户", trigger: "change" }],
      },
      userSearchOptions: [],
      userSearchLoading: false,
      userSearchTimer: null,
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },

    displayNick(row) {
      if (!row) return "—";
      const n = row.nickName != null && String(row.nickName).trim() !== "" ? String(row.nickName).trim() : "";
      if (n) return n;
      if (row.officialUserId != null) return "（未查到昵称）";
      return "—";
    },
    fetchList() {
      this.loading = true;
      this.$https(this.$api.api.selOfficialUserMgmtList, {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
          } else {
            this.tableData = [];
            this.$message.error((res.data && res.data.msg) || "加载失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    userOptionLabel(u) {
      if (!u) return "";
      const nick = (u.nickName != null && String(u.nickName).trim() !== "") ? String(u.nickName).trim() : "";
      return nick ? `${nick}（ID ${u.id}）` : `用户 ID ${u.id}`;
    },

    remoteSearchUser(query) {
      if (this.userSearchTimer) {
        clearTimeout(this.userSearchTimer);
        this.userSearchTimer = null;
      }
      const q = String(query || "").trim();
      if (!q) {
        this.userSearchOptions = [];
        return;
      }
      this.userSearchTimer = setTimeout(() => {
        this.userSearchLoading = true;
        this.$https(this.$api.api.selUser, { nickName: q, page: 1, size: 30 }, "POST")
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.userSearchOptions = res.data.data || [];
            } else {
              this.userSearchOptions = [];
            }
          })
          .catch(() => {
            this.userSearchOptions = [];
          })
          .finally(() => {
            this.userSearchLoading = false;
          });
      }, 280);
    },

    /** 编辑时拉取当前官方帐号对应用户，保证下拉能展示昵称 */
    loadUserOptionById(userId) {
      if (userId == null) return;
      this.userSearchLoading = true;
      this.$https(this.$api.api.selUser, { id: userId, page: 1, size: 1 }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200 && res.data.data && res.data.data.length) {
            this.userSearchOptions = res.data.data;
          } else {
            this.userSearchOptions = [{ id: userId, nickName: "" }];
          }
        })
        .finally(() => {
          this.userSearchLoading = false;
        });
    },

    openAdd() {
      this.dialogTitle = "新增官方帐号";
      this.userSearchOptions = [];
      this.form = { id: null, officialUserId: null, remark: "" };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    openEdit(row) {
      if (!row || !row.id) return;
      this.dialogTitle = "编辑官方帐号";
      this.form = {
        id: row.id,
        officialUserId: row.officialUserId,
        remark: row.remark || "",
      };
      this.userSearchOptions = [];
      this.loadUserOptionById(row.officialUserId);
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    onDialogClosed() {
      this.form = null;
      this.userSearchOptions = [];
      if (this.userSearchTimer) {
        clearTimeout(this.userSearchTimer);
        this.userSearchTimer = null;
      }
    },
    submitFn() {
      if (!this.$refs.formRef || !this.form) return;
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        const payload = {
          id: this.form.id,
          officialUserId: this.form.officialUserId,
          remark: this.form.remark || null,
        };
        this.$https(this.$api.api.upsertOfficialUserMgmt, payload, "POST")
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.$message.success("保存成功");
              this.dialogVisible = false;
              this.fetchList();
            } else {
              this.$message.error((res.data && res.data.msg) || "保存失败");
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    delRow(row) {
      if (!row || !row.id) return;
      this.$confirm("确定删除该条官方帐号配置？", "提示", { type: "warning" })
        .then(() => {
          return this.$https(this.$api.api.deleteOfficialUserMgmt, { id: row.id }, "GET");
        })
        .then((res) => {
          if (res && res.data && res.data.code == 200) {
            this.$message.success("已删除");
            this.fetchList();
          } else if (res && res.data) {
            this.$message.error(res.data.msg || "删除失败");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
#box {
  width: 100%;
}
.toolbar {
  margin-top: 8px;
  display: flex;
  align-items: center;
}
.official-account-table {
  font-size: 13px;
}
.user-cell {
  display: flex;
  align-items: center;
  padding: 4px 0;
  min-height: 48px;
}
.user-cell__avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
}
.user-cell__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  vertical-align: top;
}
.user-cell__avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 20px;
}
.user-cell__meta {
  margin-left: 12px;
  min-width: 0;
  flex: 1;
}
.user-cell__nick {
  font-weight: 500;
  color: #303133;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 420px;
}
.user-cell__sub {
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
  line-height: 1.3;
}
.official-account-table .btn-del {
  color: #f56c6c;
}
.field-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  margin-top: 6px;
}
.official-user-select-item ::v-deep .el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/officialUserList/index.vue